import type { PatchConferenceVisitorRegistrationBody } from "../../../../hooks/Remote/Schedule/conference-visitor-registration-patch.api";
import type { LocationInventory } from "../../../FloorManager/typings/location-inventory";
import type {
  VisitorBookingEditDraft,
  VisitorBookingTableRow
} from "../visitor-bookings-table.partial";
import { isVisitorLocationDerivedFromPlaceOrRoom } from "../../../../components/Schedule/functions/visitor-schedule-field-editable.function";
import { parseVisitorNameFromExternal } from "./parseVisitorNameFromExternal.function";
import { resolveLocationInventoryIdForPatch } from "./buildPatchVisitOnlyBookingPayload.function";

type BuildPatchContext = {
  row: VisitorBookingTableRow;
  draft: VisitorBookingEditDraft;
  locations: LocationInventory[] | undefined;
};

export function buildPatchConferenceVisitorRegistrationPayload({
  row,
  draft,
  locations
}: BuildPatchContext): PatchConferenceVisitorRegistrationBody | null {
  const body: PatchConferenceVisitorRegistrationBody = {};
  const checkedIn = Boolean(row.checkedIn);

  if (checkedIn) {
    const email = draft.externalEmail?.trim();
    if (email != null && email !== row.externalEmail?.trim()) {
      body.email = email;
    }
    const company = draft.externalCompany?.trim();
    if (company != null && company !== row.externalCompany?.trim()) {
      body.company = company;
    }
    const contacts = draft.externalContacts?.trim();
    if (contacts != null && contacts !== row.externalContacts?.trim()) {
      body.contacts = contacts;
    }
  } else {
    const { firstName, surname } = parseVisitorNameFromExternal(draft.externalName);
    const currentName = parseVisitorNameFromExternal(row.externalName);
    if (firstName != null && firstName !== currentName.firstName) {
      body.firstName = firstName;
    }
    if (surname != null && surname !== currentName.surname) {
      body.surname = surname;
    }
    const email = draft.externalEmail?.trim();
    if (email != null && email !== row.externalEmail?.trim()) {
      body.email = email;
    }
    const company = draft.externalCompany?.trim();
    if (company != null && company !== row.externalCompany?.trim()) {
      body.company = company;
    }
    const contacts = draft.externalContacts?.trim();
    if (contacts != null && contacts !== row.externalContacts?.trim()) {
      body.contacts = contacts;
    }
    const visitReason = draft.externalVisitReason?.trim();
    if (visitReason != null && visitReason !== row.externalVisitReason?.trim()) {
      body.visitReason = visitReason;
    }

    if (!isVisitorLocationDerivedFromPlaceOrRoom(row)) {
      const locationInventoryId = resolveLocationInventoryIdForPatch(locations, draft.locationName);
      const currentLocationId = row.bookingInventory?.locationInventory?.id;
      if (locationInventoryId != null && locationInventoryId !== currentLocationId) {
        body.locationInventoryId = locationInventoryId;
      }
    }
  }

  const hasChange =
    body.firstName != null ||
    body.surname != null ||
    body.email != null ||
    body.company != null ||
    body.contacts != null ||
    body.visitReason != null ||
    body.locationInventoryId != null;

  return hasChange ? body : null;
}
